import { Flex } from 'antd';
import { BackButton2 } from 'components/button/button-base';
import { ErrorListDisplay } from 'components/ErrorDisplay';
import { PrintableRootPage } from 'components/page/page-2';
import { useCurrentClinicHasPaymentMethod } from 'lib/hooks/tanstack/use-getProductPrice';
import { useQueryErrorNotifier } from 'lib/hooks/use-query-error-notifier';
import useSearchParams from 'lib/hooks/use-searchParams';
import { ErrorListContext, useErrorList } from 'lib/utils/useErrorList';
import { ReactNode } from 'react';

interface PurchaseLayoutProps {
  title: string;
  children: ReactNode;
  onBack?: () => void;
}

export function PurchaseLayout({
  title,
  children,
  onBack
}: PurchaseLayoutProps) {
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo');
  const errorList = useErrorList();

  /**
   * Check if the organisation has a payment method set up
   */
  const hasPaymentMethodQuery = useCurrentClinicHasPaymentMethod();

  useQueryErrorNotifier(hasPaymentMethodQuery, errorList);
  const hasPaymentMethod =
    hasPaymentMethodQuery.data?.data.hasPaymentMethod === true;

  return (
    <ErrorListContext value={{ errorList }}>
      <Flex gap={16}>
        <div>
          {onBack ? (
            <BackButton2 type="text" onClick={onBack}>
              Back
            </BackButton2>
          ) : (
            returnTo !== null && (
              <BackButton2 type="text" href={returnTo}>
                Back
              </BackButton2>
            )
          )}
        </div>
      </Flex>
      {hasPaymentMethod && (
        <PrintableRootPage title={title}>{children}</PrintableRootPage>
      )}
      <ErrorListDisplay errorList={errorList} />
    </ErrorListContext>
  );
}
